/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import Link from "./link"
import { ab } from "../theme"

const Footer = ({
  footerItems,
  footerSocialMediaItems,
  language,
  seoLinks,
}) => (
  <footer
    sx={{
      variant: "innerSpacingContainer",
    }}
  >
    <div
      sx={{
        display: "flex",
        fontSize: 1,
        textAlign: ab({ _: "center", md: "left" }),
        flexDirection: ab({ _: "column-reverse", md: "row" }),
      }}
    >
      <div
        sx={{
          flex: ab({ _: 2, lg: 1 }),
          paddingTop: ab({ _: 40, md: 0 }),
          color: "text",
        }}
      >
        &copy; 2020 GBA Group
      </div>
      <div
        sx={{
          flex: 5,
          alignSelf: ab({ _: "center", md: "flex-end" }),
          textAlign: "right",
        }}
      >
        {footerSocialMediaItems &&
          footerSocialMediaItems.map((footerItem, index) => (
            <Link
              language={language}
              seoLinks={seoLinks}
              to={
                footerItem.url
                  ? footerItem.url.linktype === "story"
                    ? footerItem.url.story && footerItem.url.story.full_slug
                      ? footerItem.url.story.full_slug
                      : footerItem.url.cached_url
                    : footerItem.url.cached_url
                  : ""
              }
              sx={{ variant: "styles.footerlink" }}
              key={index}
            >
              {footerItem.displayName}
            </Link>
          ))}

        {footerItems &&
          footerItems.map((footerItem, index) => (
            <Link
              language={language}
              seoLinks={seoLinks}
              to={
                footerItem.url
                  ? footerItem.url.linktype === "story"
                    ? footerItem.url.story && footerItem.url.story.full_slug
                      ? footerItem.url.story.full_slug
                      : footerItem.url.cached_url
                    : footerItem.url.cached_url
                  : ""
              }
              sx={{ variant: "styles.footerlink" }}
              key={index}
            >
              {footerItem.displayName}
            </Link>
          ))}
      </div>
    </div>
  </footer>
)

Footer.propTypes = {
  footerItems: PropTypes.array,
  footerSocialMediaItems: PropTypes.array,
  language: PropTypes.oneOf(["de", "en"]),
  seoLinks: PropTypes.object.isRequired,
}

Footer.defaultProps = {
  footerItems: [],
  seoLinks: {},
  language: "de",
}

export default Footer
